<template>
  <el-color-picker v-model="color" />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      perfix: "",
    };
  },
  computed: {
    color: {
      get() {
        if (parseInt(this.value, 16).toString(16) === this.value) {
          return this.perfix + this.value;
        }
        return this.value;
      },
      set(val) {
        this.$emit("input", this.perfix ? val.replace(/^#/, "") : val);
      },
    },
  },
};
</script>
